module.exports = __webpack_public_path__ + "static/media/value-proposition-talent-v2.69183914.png";